import { render, staticRenderFns } from "./AssetTenanciesView.vue?vue&type=template&id=5464d23c&scoped=true"
import script from "./AssetTenanciesView.vue?vue&type=script&lang=js"
export * from "./AssetTenanciesView.vue?vue&type=script&lang=js"
import style0 from "./AssetTenanciesView.vue?vue&type=style&index=0&id=5464d23c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5464d23c",
  null
  
)

export default component.exports